import { locationActions } from './reducers';

export const {
  getCurrentLocationAction,
  setCurrentLocationAction,
  setLocationErrorAction,
  clearCurrentLocationAction,
} = locationActions;
